import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_cart_6: FaireProductEntity = {
  token: "atc_fs_cart_6",
  type: "product",
  name: "Better With Butter Jotter",
  brandName: "Be Light Candle Re",
  brandToken: "be-light-candle-re",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a46ba3f323057317d15a91722a820ca542cd9eeaea646f5f51fc594546340b9f.webp",
  priceDollars: 9,
  msrpDollars: 18,
  description: "ATC cart product seed",
  tags: ["stationery", "atc", "cart"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
